import { gql } from '@apollo/client';

export const archiveDestinationMutation = gql`
  mutation archiveDestination($destinationId: String!) {
    archiveDestination(destinationId: $destinationId) {
      ... on ArchiveDestinationSuccess {
        destinationId
        archived
      }
      ... on ArchiveDestinationFailure {
        message
      }
    }
  }
`;
